export class LayoutConfig {
  showHeader: boolean = true;
  showFooter: boolean = true;
  showHeaderLinks: boolean = true;
}
